(function () {
  var MOBILE_MAX = 1024;
  var ACTIVE_CLASS = 'am-shoppable-hotspot--active';
  var OPEN_CLASS = 'am-shoppable-tooltip--open';
  var INIT_ATTR = 'data-am-shoppable-carousel-init';
  var CLOSE_DELAY_MS = 350;

  function isMobile() {
    return window.innerWidth < MOBILE_MAX;
  }

  function slideWidth(track) {
    var slide = track.querySelector('.am-shoppable-mobile-carousel__slide');
    if (slide && slide.offsetWidth) return slide.offsetWidth;
    return track.clientWidth || 0;
  }

  function getScrollIndex(track, count) {
    var w = slideWidth(track);
    if (!w) return 0;
    return Math.max(0, Math.min(Math.round(track.scrollLeft / w), count - 1));
  }

  function initRoot(root) {
    if (!root || root.getAttribute(INIT_ATTR)) return;

    var carousel = root.querySelector('[data-am-shoppable-mobile-carousel]');
    var track = root.querySelector('[data-am-carousel-track]');
    var hotspots = root.querySelectorAll('.am-shoppable-hotspot[data-am-hotspot-index]');
    var stage = root.querySelector('.am-shoppable-image__stage');

    if (!hotspots.length) {
      root.setAttribute(INIT_ATTR, '1');
      return;
    }

    root.setAttribute(INIT_ATTR, '1');

    var slideCount = hotspots.length;
    var index = 0;
    var scrollPending = false;

    function setCarouselIndex(i) {
      if (!carousel) return;
      if (i < 0) i = 0;
      if (i >= slideCount) i = slideCount - 1;
      index = i;
      carousel.style.setProperty('--am-carousel-index', String(i));
    }

    function setActiveHotspot(i) {
      hotspots.forEach(function (h) {
        var hi = parseInt(h.getAttribute('data-am-hotspot-index'), 10);
        if (hi === i) h.classList.add(ACTIVE_CLASS);
        else h.classList.remove(ACTIVE_CLASS);
      });
    }

    function applyIndex(i) {
      setCarouselIndex(i);
      setActiveHotspot(i);
    }

    /** Measure tooltip shift/arrow while closed. Calls done() when finished. */
    function positionDesktopTooltip(hotspotEl, done) {
      if (isMobile() || !stage) {
        if (done) done();
        return;
      }

      var dot = hotspotEl.querySelector('.wt-dot');
      var tooltip = hotspotEl.querySelector('.wt-dot__tooltip.am-shoppable-tooltip--desktop-only');
      if (!dot || !tooltip) {
        if (done) done();
        return;
      }

      function readShiftPx() {
        var raw = tooltip.style.getPropertyValue('--am-tooltip-shift-x') || '0px';
        var n = parseFloat(String(raw).replace('px', '').trim());
        return isNaN(n) ? 0 : n;
      }

      function commitArrow() {
        var dotRect = dot.getBoundingClientRect();
        var hotspotCenterX = dotRect.left + dotRect.width / 2;
        var tipRect2 = tooltip.getBoundingClientRect();
        var arrowLeft = hotspotCenterX - tipRect2.left;
        var maxW = Math.max(tipRect2.width, 10);
        var arrowClamped = Math.max(5, Math.min(maxW - 5, arrowLeft));
        tooltip.style.setProperty('--am-tooltip-arrow-left', arrowClamped + 'px');
      }

      function bounds() {
        var stageRect = stage.getBoundingClientRect();
        var gutter = 8;
        var vw =
          window.visualViewport && window.visualViewport.width
            ? window.visualViewport.width
            : window.innerWidth;
        var leftBound = Math.max(gutter, stageRect.left);
        var rightBound = Math.min(vw - gutter, stageRect.right);
        return { leftBound: leftBound, rightBound: rightBound };
      }

      tooltip.style.setProperty('--am-tooltip-shift-x', '0px');
      tooltip.style.setProperty('--am-tooltip-arrow-left', '10px');

      var guard = 0;
      function step() {
        if (++guard > 12) {
          commitArrow();
          if (done) done();
          return;
        }

        var tipRect = tooltip.getBoundingClientRect();
        if (tipRect.width < 4 || tipRect.height < 4) {
          requestAnimationFrame(step);
          return;
        }

        var b = bounds();
        var need = 0;
        if (tipRect.right > b.rightBound) need = b.rightBound - tipRect.right;
        else if (tipRect.left < b.leftBound) need = b.leftBound - tipRect.left;

        if (Math.abs(need) < 0.5) {
          commitArrow();
          if (done) done();
          return;
        }

        var next = readShiftPx() + need;
        tooltip.style.setProperty('--am-tooltip-shift-x', next + 'px');
        void tooltip.offsetHeight;
        requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    function bumpTipGen(hotspotEl) {
      hotspotEl._amTipOpenGen = (hotspotEl._amTipOpenGen || 0) + 1;
      return hotspotEl._amTipOpenGen;
    }

    function tipImagesReady(tooltip, cb) {
      var imgs = Array.prototype.slice.call(tooltip.querySelectorAll('img'));
      if (!imgs.length) {
        cb();
        return;
      }
      var pending = imgs.length;
      function one() {
        if (--pending <= 0) cb();
      }
      imgs.forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          one();
          return;
        }
        var finished = false;
        function done() {
          if (finished) return;
          finished = true;
          one();
        }
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        if (typeof img.decode === 'function') {
          img.decode().then(done).catch(done);
        }
      });
    }

    function prewarmDesktopTooltip(tooltip) {
      if (!tooltip || tooltip.getAttribute('data-am-tip-prewarmed') === '1') return;
      tooltip.setAttribute('data-am-tip-prewarmed', '1');
      void window.getComputedStyle(tooltip).clipPath;
      void tooltip.offsetHeight;
      Array.prototype.forEach.call(tooltip.querySelectorAll('img'), function (img) {
        if (typeof img.decode === 'function') {
          img.decode().catch(function () {});
        }
      });
    }

    function openDesktopTooltip(hotspotEl) {
      if (isMobile()) return;
      var tooltip = hotspotEl.querySelector('.wt-dot__tooltip.am-shoppable-tooltip--desktop-only');
      if (!tooltip) return;

      prewarmDesktopTooltip(tooltip);

      // Instantly clear every other tip so only one can expand
      hotspots.forEach(function (other) {
        if (other === hotspotEl) return;
        if (other._amTipCloseTimer) {
          clearTimeout(other._amTipCloseTimer);
          other._amTipCloseTimer = null;
        }
        bumpTipGen(other);
        var otherTip = other.querySelector('.wt-dot__tooltip.am-shoppable-tooltip--desktop-only');
        if (!otherTip) return;
        if (otherTip.classList.contains(OPEN_CLASS) || parseFloat(window.getComputedStyle(otherTip).opacity) > 0.02) {
          otherTip.style.transition = 'none';
          otherTip.style.animation = 'none';
          otherTip.classList.remove(OPEN_CLASS);
          void otherTip.offsetHeight;
          otherTip.style.transition = '';
          otherTip.style.animation = '';
        }
      });

      if (hotspotEl._amTipCloseTimer) {
        clearTimeout(hotspotEl._amTipCloseTimer);
        hotspotEl._amTipCloseTimer = null;
      }

      var opacityNow = parseFloat(window.getComputedStyle(tooltip).opacity) || 0;
      if (tooltip.classList.contains(OPEN_CLASS) && opacityNow >= 0.98) return;

      var gen = bumpTipGen(hotspotEl);

      // Commit closed from-state so the expand keyframe always starts from scratch
      tooltip.style.transition = 'none';
      tooltip.style.animation = 'none';
      tooltip.classList.remove(OPEN_CLASS);
      void tooltip.offsetHeight;

      tipImagesReady(tooltip, function () {
        if (gen !== hotspotEl._amTipOpenGen) {
          tooltip.style.transition = '';
          tooltip.style.animation = '';
          return;
        }
        positionDesktopTooltip(hotspotEl, function () {
          if (gen !== hotspotEl._amTipOpenGen) {
            tooltip.style.transition = '';
            tooltip.style.animation = '';
            return;
          }
          tooltip.style.transition = '';
          tooltip.style.animation = '';
          void tooltip.offsetHeight;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              if (gen !== hotspotEl._amTipOpenGen) return;
              tooltip.classList.add(OPEN_CLASS);
            });
          });
        });
      });
    }

    function repositionOpenDesktopTooltip(hotspotEl) {
      if (isMobile()) return;
      var tooltip = hotspotEl.querySelector('.wt-dot__tooltip.am-shoppable-tooltip--desktop-only');
      if (!tooltip || !tooltip.classList.contains(OPEN_CLASS)) return;
      var gen = hotspotEl._amTipOpenGen || 0;
      tooltip.style.transition = 'none';
      positionDesktopTooltip(hotspotEl, function () {
        if (gen !== hotspotEl._amTipOpenGen) {
          tooltip.style.transition = '';
          return;
        }
        void tooltip.offsetHeight;
        tooltip.style.transition = '';
      });
    }

    function closeDesktopTooltipNow(hotspotEl) {
      var tooltip = hotspotEl.querySelector('.wt-dot__tooltip.am-shoppable-tooltip--desktop-only');
      if (!tooltip) return;
      bumpTipGen(hotspotEl);
      tooltip.style.animation = 'none';
      void tooltip.offsetHeight;
      tooltip.style.animation = '';
      tooltip.style.transition = '';
      void tooltip.offsetHeight;
      requestAnimationFrame(function () {
        tooltip.classList.remove(OPEN_CLASS);
      });
    }

    function scheduleCloseDesktopTooltip(hotspotEl) {
      if (isMobile()) return;
      bumpTipGen(hotspotEl);
      var tooltip = hotspotEl.querySelector('.wt-dot__tooltip.am-shoppable-tooltip--desktop-only');
      if (tooltip) tooltip.style.transition = '';
      if (hotspotEl._amTipCloseTimer) clearTimeout(hotspotEl._amTipCloseTimer);
      hotspotEl._amTipCloseTimer = setTimeout(function () {
        hotspotEl._amTipCloseTimer = null;
        closeDesktopTooltipNow(hotspotEl);
      }, CLOSE_DELAY_MS);
    }

    function repositionDesktopIfOpen() {
      if (isMobile()) return;
      var openTip = root.querySelector('.wt-dot__tooltip.am-shoppable-tooltip--desktop-only.' + OPEN_CLASS);
      if (!openTip) return;
      var hs = openTip.closest('.am-shoppable-hotspot');
      if (hs) repositionOpenDesktopTooltip(hs);
    }

    function scrollToIndex(i, smooth) {
      if (!track) return;
      if (i < 0) i = 0;
      if (i >= slideCount) i = slideCount - 1;
      var w = slideWidth(track);
      if (!w) return;
      track.scrollTo({
        left: w * i,
        behavior: smooth === false ? 'auto' : 'smooth',
      });
      applyIndex(i);
    }

    function onScroll() {
      if (!isMobile()) return;
      if (scrollPending) return;
      scrollPending = true;
      requestAnimationFrame(function () {
        scrollPending = false;
        var i = getScrollIndex(track, slideCount);
        applyIndex(i);
      });
    }

    if (track) {
      track.addEventListener('scroll', onScroll, { passive: true });
    }

    hotspots.forEach(function (h) {
      var circle = h.querySelector('.wt-dot__circle');
      var tipEl = h.querySelector('.wt-dot__tooltip.am-shoppable-tooltip--desktop-only');
      if (tipEl && !isMobile()) prewarmDesktopTooltip(tipEl);

      function onEnter() {
        openDesktopTooltip(h);
      }
      function onLeave(e) {
        var rel = e && e.relatedTarget;
        if (rel && h.contains(rel)) return;
        scheduleCloseDesktopTooltip(h);
      }

      h.addEventListener('mouseenter', onEnter);
      h.addEventListener('mouseleave', onLeave);

      if (circle) {
        function goToHotspot(e) {
          if (!isMobile()) return;
          var hi = parseInt(h.getAttribute('data-am-hotspot-index'), 10);
          if (!isNaN(hi)) {
            e.preventDefault();
            scrollToIndex(hi);
          }
        }

        circle.addEventListener('click', goToHotspot, true);
        circle.addEventListener('keydown', function (e) {
          if (!isMobile()) return;
          if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13) {
            goToHotspot(e);
          }
        });
      }
    });

    window.addEventListener('resize', function () {
      if (isMobile()) {
        if (track) scrollToIndex(index, false);
        hotspots.forEach(function (h) {
          var tip = h.querySelector('.wt-dot__tooltip.am-shoppable-tooltip--desktop-only');
          if (tip) tip.classList.remove(OPEN_CLASS);
        });
      } else {
        repositionDesktopIfOpen();
      }
    });

    applyIndex(0);
    if (track) track.scrollLeft = 0;
  }

  function run() {
    document.querySelectorAll('[data-am-shoppable-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var el = ev.target;
    if (!el || !el.classList || !el.classList.contains('am-shoppable-image-section')) return;
    var root = el.querySelector('[data-am-shoppable-root]');
    if (root) {
      root.removeAttribute(INIT_ATTR);
      initRoot(root);
    }
  });
})();
